<template>
  <div id="app">
    <router-view />

    <!-- <footerBar></footerBar> -->
  </div>
</template>

<script>
import {visit} from '@/api/common'
export default {
  name: "App",
  data() {
    return {
      startTime: "",
      beforeUnload_time: "",
      _gap_time: "",
    };
  },
  created(){
    this.postMessage()
  },
  mounted() {
    // 监听浏览器关闭
    this.startTime = new Date().getTime();
    this.time = this.parseTime(new Date())
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
  },
  destroyed() {
    window.removeEventListener("beforeunload", (e) =>
      this.beforeunloadHandler(e)
    );
  },
  methods: {
    beforeunloadHandler(e) {
      this.beforeUnload_time = new Date().getTime();
      var retentionTime = Number(((new Date().getTime() - this.startTime)/1000).toFixed(2));
      visit({
          visitTime:this.time,
          retentionTime
        }).then(res=>{
          console.log("执行关闭方法");
        })
    },
    // unloadHandler() {
    //   this._gap_time = new Date().getTime() - this.beforeUnload_time;
    //   var retentionTime = new Date().getTime() - this.startTime;
    //   console.log(this._gap_time);
    //   //判断是窗口关闭还是刷新
    //   if (this._gap_time <= 5) {
    //     visit({
    //       retentionTime
    //     }).then(res=>{
    //       console.log("执行关闭方法");
    //     })
    //   }
    // },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue